// use this module to prefetch as much dynamic data as we can as the app loads

import { getBet, getAdtag, getPreview } from "./api";

const searchParams = new URLSearchParams(window.location.search);

export const bet = (operator?: string) => {
  const queries: {
    id?: string;
    ref?: string;
    clickUrl?: string;
    targetUrl?: string;
    useMockData?: string;
    operator?: string;
    [x: string]: string | undefined; // This is to allow any macro set on campaigns to be passed to the bet endpoint
  } = { operator };

  searchParams.forEach((value, param) => {
    queries[param] = value;
  });

  const { id, ref, clickUrl, targetUrl, useMockData, ...rest } = queries;
  return getBet(id, ref, clickUrl, targetUrl, useMockData, rest);
};

export const preview = (operator?: string) =>
  getPreview({
    competitors: searchParams.get("competitors") || undefined,
    competitions: searchParams.get("competitions") || undefined,
    marketIds: searchParams.get("marketIds") || undefined,
    marketTypes: searchParams.get("marketTypes") || undefined,
    limit: searchParams.get("limit") || undefined,
    operator: operator || searchParams.get("operator") || undefined,
    sport: searchParams.get("sport") || undefined,
    eventId: searchParams.get("eventId") || undefined
  });

export const adtag = getAdtag(
  searchParams.get("id"),
  searchParams.get("useMockBrand") || undefined
);

export const getPrototype = () => {
  return searchParams.get("prototype");
};
